export class LevelState {
    public constructor(public moveCount: number,
                       public won: boolean,
                       public lastLevel = false) {}
}
